import Modal from '@components/modal/modal.component';
import { CopyableText } from '@components/copyable-text/copyable-text';

import styles from './created-giftcard-modal.module.scss';

type Props = {
    code: string;
    onConfirm: () => void;
};

const CreatedGiftCardModal = ({ code, onConfirm }: Props) => {
    return (
        <Modal onConfirm={onConfirm} confirmText="De acuerdo">
            <div className={styles.header}>
                <h4>Giftcard creada</h4>
            </div>
            <div className={styles.content}>
                <p>¡Todo perfecto! Este es el código de tu nueva giftcard:</p>
                <div className={styles.spacer}>
                    <CopyableText text={code} />
                </div>
                <p>
                    Si necesitas el código, te aconsejamos copiarlo de una vez
                    para usarlo inmediatamente
                </p>
            </div>
        </Modal>
    );
};

export { CreatedGiftCardModal };
